(() => {
  if (customElements.get('routine-builder')) {
    return;
  }

  class RoutineBuilder extends HTMLElement {
    constructor() {
      super();

      this.swiper = null;
      this.cardsSize = 'default';
      this.shouldDestroyOnDesktop = this.hasAttribute('data-destroy');
      this.breakpoints = {
        desktop: 1360
      };
    }

    connectedCallback() {
      this.initSwiper();
      this.toggleSwiperHandler();
      window.addEventListener('resize', debounce(this.toggleSwiperHandler.bind(this), 500));
    }

    initSwiper() {
      const swiperContainer = this.querySelector('.routine-builder__products-slider');

      const swiperNext = this.querySelector('.routine-builder__products-control-next');
      const swiperPrev = this.querySelector('.routine-builder__products-control-prev');

      const sizeCardSettings = {
        default: {
          slidesPerView: 1.2,
          spaceBetween: 16,
          breakpoints: {
            [990]: {
              slidesPerView: 1.8
            },
            [1200]: {
              slidesPerView: 2.5,
              spaceBetween: 20,
            },
          },
        }
      };


      if (!swiperContainer) return;

      const mainSettings = {
        navigation: {
          nextEl: swiperNext,
          prevEl: swiperPrev,
        },
        speed: 300,
        ...sizeCardSettings[this.cardsSize]
      };

      this.swiper = new Swiper(swiperContainer, mainSettings);
    }

    toggleSwiperHandler() {
      if (!this.shouldDestroyOnDesktop) return;
      try {
        this.toggleSwiper(window.innerWidth >= this.breakpoints.desktop);
      } catch(e) {}
    }

    toggleSwiper(destroy) {
      if (destroy) {
        this.swiper.destroy(true, true);
      } else {
        this.swiper = new Swiper(swiperContainer, mainSettings);
      }
    }
  }

  customElements.define('routine-builder', RoutineBuilder);
})();
